import axios from 'axios';

export const saveCompanyProfile = (companyInfo, firebase) => {
  return firebase
    .auth()
    .currentUser.getIdToken(false)
    .then(idToken => {
      return axios
        .post(`${process.env.REACT_APP_FIREBASE_URL}/saveCompanyProfile`, {
          idToken,
          companyInfo
        })
        .then(res => {
          if (res.status == 200 && res.data) {
            if (res.data && res.data.status == 'success') {
              return res.data;
            }
          }
        });
    });
};



// WEBPACK FOOTER //
// ./src/services/CompanyServices.js